import { DialogDescription, DialogTitle } from '@radix-ui/react-dialog'
import { useShallow } from 'zustand/shallow'

import { Button } from '@/components/atoms/Button'
import { Dialog, DialogContent } from '@/components/atoms/Dialog'
import { useScopedI18n } from '@/locales/client'
import type { DialogTypes } from '@/stores/DialogsStore'
import useDialogsStore from '@/stores/DialogsStore'

const DIALOG_ID: DialogTypes = 'expandedPorts'

function ExpandedPortsDialog() {
  const t = useScopedI18n('dialogs.expandedPorts')
  const { open } = useDialogsStore(useShallow(state => state.dialogs.expandedPorts))
  const toggle = useDialogsStore(useShallow(state => state.toggle))

  const handleToggle = () => toggle(DIALOG_ID)

  return (
    <Dialog open={open} onOpenChange={handleToggle}>
      <DialogContent className="flex h-fit flex-col items-center justify-center gap-8 p-12 text-center">
        <DialogTitle asChild>
          <h3 className="text-3xl font-bold leading-tight text-rsf-black">
            {t('title')}
          </h3>
        </DialogTitle>
        <DialogDescription asChild>
          <p className="text-xl font-normal leading-snug text-rsf-black">
            {t('subtitle')}
          </p>
        </DialogDescription>

        <Button className="mt-8" onClick={handleToggle}>
          {t('confirmButton')}
        </Button>
      </DialogContent>
    </Dialog>
  )
}

export default ExpandedPortsDialog
